module.exports = __webpack_public_path__ + "img/ill-home-clients-header.079aebf2.svg";